module.exports = __webpack_public_path__ + "img/Feature.c9dcfceb.png";